import { MicDemo } from "../../ui/MicDemo";
import { MorseDemo } from "../../ui/MorseDemo";

interface MorseProps {
  onNavigate: (to: string) => void;
}

interface GameEntry {
  slug: string;
  name: string;
  blurb: string;
  ready: boolean;
}

const GAMES: readonly GameEntry[] = [
  {
    slug: "flashcards",
    name: "Flash cards",
    blurb: "See a Morse pattern, name the letter. Tracks your hit-rate per character.",
    ready: true,
  },
  {
    slug: "hangman",
    name: "Hangman",
    blurb: "Decode the word letter by letter. Single-player vs the clock.",
    ready: true,
  },
  {
    slug: "hangman-multi",
    name: "Hangman — two-player Bluetooth",
    blurb: "One player hosts and picks the word, the other guesses. Phones must be close (~10 m). Mobile app only.",
    ready: true,
  },
  {
    slug: "translate",
    name: "Translate",
    blurb: "Type a message, play it as audio or as flashing light. Hide the text and show the phone for someone else to decode.",
    ready: true,
  },
];

/// Morse module hub. Demos at the top (encode + listen), games
/// below. Games link to `/play/morse/<game>` once they're built.
export function Morse({ onNavigate }: MorseProps) {
  return (
    <>
      <h2>Demos</h2>
      <MorseDemo />
      <MicDemo />

      <h2 style={{ marginTop: 32 }}>Games</h2>
      {GAMES.map((g) => (
        <div key={g.slug} className="card">
          <h3 style={{ marginBottom: 4 }}>
            {g.name}
            {!g.ready && (
              <span className="pill" style={{ marginLeft: 8, fontSize: 12 }}>
                coming soon
              </span>
            )}
          </h3>
          <p className="small muted" style={{ marginBottom: 12 }}>
            {g.blurb}
          </p>
          {g.ready ? (
            <button
              onClick={() => onNavigate(`/play/morse/${g.slug}`)}
              className="secondary"
            >
              Play
            </button>
          ) : (
            <button disabled className="secondary">
              Not yet
            </button>
          )}
        </div>
      ))}
    </>
  );
}
